<template>
   <div>
      <div class="row">
         <!-- Start col -->
         <div class="col-md-12 col-lg-12 col-xl-12">
            <div class="text-center mt-1 mb-2">
                  <!--h4>Bienvenido a la página de Promociones</h4-->
            </div>
         </div>
         <!-- End col -->
      </div>

      <div class="row">
         <!-- Lista promociones -->
         <promotion 
            v-for="promo in promotions" :key="promo.id"
            :id="promo.id"
            :title="promo.title"
            :content="promo.content"
            :image-url="promo.image"
            :featured="promo.featured"
            :valid-to="promo.valid_to"
            :clickable="canClickPromotions"
         />
         <!-- Fin Lista promociones -->
      </div>

   </div>
</template>

<script>

import { mapState } from 'vuex';
import Promotion from "@clients/Promotion.vue"
import dateHelper from "@mixins/dateHelper"
export default {
   components: {
      Promotion
   },
   mixins: [dateHelper],
   data() {
      return {
         promotions: [],
      }
   },
   async mounted(){
      await this.getPromotionsList();
   },
   computed: {
      ...mapState("auth", ["special_customer"]),
      canClickPromotions(){
         return this.special_customer !== true
      }
   },
   methods: {
      async getPromotionsList(){
         this.showLoader()
         const res = await this.xget('/promociones');
         if(res.success){        
            this.setPromotions(res.data);
         }
         this.stopLoader()
      },
      setPromotions(rawPromotions){
         this.promotions = [];
         rawPromotions.forEach(promo => {
            this.promotions.push({
               id: promo.ID,
               title: promo.Nombre,
               content: promo.Descripcion,
               featured: promo.Destacado,
               image: promo.Url_Imagen,
               valid_to: this.midDateFormat(promo.Fecha_Fin),
            });
         });
      },
   },
   
}
</script>